import { useInfiniteQuery, useQuery } from "react-query";
import { extractReportsCursor, getReports } from "./getReports";
import getAppointments from "../../PatientRecords/services/getAppointments";
import getEncounters from "../../PatientRecords/services/getEncounters";
var useGetPatientAttachments = function useGetPatientAttachments(workspaceId, patientId) {
  var reports = useInfiniteQuery(["patient-reports", workspaceId, patientId], function (_ref) {
    var pageParam = _ref.pageParam;
    return getReports(patientId, pageParam);
  }, {
    enabled: !!workspaceId && !!patientId,
    getNextPageParam: function getNextPageParam(lastPage) {
      return extractReportsCursor(lastPage.next);
    },
    refetchOnMount: false
  });
  var appointments = useQuery(["patient-appointments", workspaceId, patientId], function () {
    return getAppointments(workspaceId, Number(patientId), null);
  }, {
    enabled: !!workspaceId && !!patientId
  });
  var encounters = useInfiniteQuery(["patient-encounters", workspaceId, patientId], function (_ref2) {
    var _ref2$pageParam = _ref2.pageParam,
      pageParam = _ref2$pageParam === void 0 ? 1 : _ref2$pageParam;
    return getEncounters(workspaceId, Number(patientId), pageParam, {
      dateFilter: [null, null],
      statusFilter: null
    });
  }, {
    enabled: !!workspaceId && !!patientId,
    getNextPageParam: function getNextPageParam(lastPage) {
      return lastPage.has_next ? lastPage.page + 1 : undefined;
    },
    refetchOnMount: false
  });
  return {
    reports: reports,
    appointments: appointments,
    encounters: encounters
  };
};
export default useGetPatientAttachments;